/** Utilidades de dibujo — estilo harmony / soft UI (referencia tetris musical). */

export function shadeColor(hex, percent) {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + percent));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00ff) + percent));
  const b = Math.min(255, Math.max(0, (num & 0x0000ff) + percent));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
}

export function setupHiDpiCanvas(canvas, cssW, cssH) {
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  canvas.width = Math.round(cssW * dpr);
  canvas.height = Math.round(cssH * dpr);
  canvas.style.width = `${cssW}px`;
  canvas.style.height = `${cssH}px`;
  const ctx = canvas.getContext('2d');
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  return { ctx, w: cssW, h: cssH };
}

export function drawCellWell(ctx, px, py, size) {
  ctx.fillStyle = 'rgba(255, 255, 255, 0.35)';
  ctx.beginPath();
  ctx.roundRect(px + 0.5, py + 0.5, size - 1, size - 1, size * 0.18);
  ctx.fill();
  ctx.strokeStyle = 'rgba(203, 213, 225, 0.55)';
  ctx.lineWidth = 0.75;
  ctx.stroke();
}

/** Marco del tablero — panel claro con sombra suave. */
export function drawCloudGlassFrame(ctx, w, h, innerX, innerY, innerW, innerH) {
  ctx.fillStyle = '#ffffff';
  ctx.shadowColor = 'rgba(30, 58, 95, 0.12)';
  ctx.shadowBlur = 16;
  ctx.shadowOffsetY = 4;
  ctx.beginPath();
  ctx.roundRect(0, 0, w, h, 18);
  ctx.fill();
  ctx.shadowBlur = 0;
  ctx.shadowOffsetY = 0;

  ctx.strokeStyle = 'rgba(226, 232, 240, 0.9)';
  ctx.lineWidth = 2;
  ctx.stroke();

  const field = ctx.createLinearGradient(innerX, innerY, innerX, innerY + innerH);
  field.addColorStop(0, '#f1f5f9');
  field.addColorStop(1, '#e8edf3');
  ctx.fillStyle = field;
  ctx.beginPath();
  ctx.roundRect(innerX, innerY, innerW, innerH, 12);
  ctx.fill();

  ctx.strokeStyle = 'rgba(203, 213, 225, 0.65)';
  ctx.lineWidth = 1;
  ctx.stroke();
}

export function drawOrnateWoodFrame(ctx, w, h, innerX, innerY, innerW, innerH) {
  drawCloudGlassFrame(ctx, w, h, innerX, innerY, innerW, innerH);
}

/** Bloque con bisel suave y color vibrante. */
export function drawPuffyNoteBlock(ctx, px, py, size, note, color, opts = {}) {
  const { alpha = 1, glow = null, glowPulse = 0, ghost = false } = opts;
  ctx.save();
  ctx.globalAlpha = ghost ? 0.22 : alpha;

  const r = size * 0.2;
  const depth = size * 0.055;

  if (glow) {
    ctx.shadowColor = glow;
    ctx.shadowBlur = 14 + glowPulse * 18;
  }

  ctx.fillStyle = shadeColor(color, -32);
  ctx.beginPath();
  ctx.roundRect(px + depth, py + depth * 1.15, size, size, r);
  ctx.fill();

  const bodyGrad = ctx.createLinearGradient(px, py, px + size, py + size);
  bodyGrad.addColorStop(0, shadeColor(color, 18));
  bodyGrad.addColorStop(0.45, color);
  bodyGrad.addColorStop(1, shadeColor(color, -22));
  ctx.fillStyle = bodyGrad;
  ctx.beginPath();
  ctx.roundRect(px, py, size - depth * 0.35, size - depth * 0.35, r);
  ctx.fill();

  ctx.fillStyle = 'rgba(255, 255, 255, 0.55)';
  ctx.beginPath();
  ctx.ellipse(px + size * 0.28, py + size * 0.22, size * 0.2, size * 0.11, -0.4, 0, Math.PI * 2);
  ctx.fill();

  ctx.strokeStyle = 'rgba(255, 255, 255, 0.35)';
  ctx.lineWidth = 1.5;
  ctx.beginPath();
  ctx.roundRect(px, py, size - depth * 0.35, size - depth * 0.35, r);
  ctx.stroke();

  ctx.shadowBlur = 0;
  ctx.fillStyle = ghost ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.95)';
  ctx.font = `800 ${Math.floor(size * 0.42)}px Fredoka, Nunito, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(note, px + size * 0.48, py + size * 0.52);

  ctx.restore();
}
